import React, {useState, useEffect} from "react";
import axios from "axios";
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { FaRegClock } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import imgBlogDefault from "../../images/blog.webp"
import ReactHtmlParser from 'react-html-parser';
import { Section, WrapperBlogs } from "../DesignSystem/SelfTissus/ContainersST";
import BoutonTransparentBtnST from "../DesignSystem/SelfTissus/BoutonTransparentBtn";
import { Card } from 'antd';
const { Meta } = Card;

const CardStyled = styled(Card)`
  cursor: default;
  &>.ant-card-body>.contBlog> img,  &>.ant-card-body>.contBlog> div > img, &>.ant-card-body>.contBlog> p >img {
    display: none;
  } &>.ant-card-body>.contBlog> div, &>.ant-card-body>.contBlog> p  {
    display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  `;

const Infos = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding: 10px 0 20px 0;
  &>span {
    color :${props => props.theme.grey09ST};
    font-size: 13px;
  }
  `;

const Title = styled.h2`
margin: 0 0 20px 0;
font-size: 29px;
`


export default function BlogListeMiniST({data, blogs}) {

  const [isLoading, setIsLoading] = useState(false);
  const [dataBlogs, setDataBlogs] = useState([]);

  // useEffect(() => {
  //   if (data?.WebBlog) {
  //     setIsLoading(true);
  //     setDataBlogs(data.WebBlog);
  //     setIsLoading(false);
  //   } else if (blogs?.Atelier?.WebBlog) {
  //     setIsLoading(true);
  //     setDataBlogs(blogs.WebBlog);
  //     setIsLoading(false);
  //   } elsse if (blogs?.WebBlog) {
console.log("data1",  blogs);
function FormateDate(date){
  if(date !== undefined && date !== null && date !== ""){
    const dateObj = new Date(date);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return dateObj.toLocaleDateString('fr-FR', options);
  }
  return "";
}


  return (
      blogs && <Section className="noPadding">
        {data?.Titre && data?.Titre !=="WebComposant" ? <h2 className="center">{data?.Titre}</h2> : null}
         <WrapperBlogs>
          {
            blogs && blogs?.WebBlog?.sort((a, b) => a.Tri - b.Tri).map((item, i) => {
              return (
                <CardStyled
                  key={i}
                  hoverable
                  className="cardBlog"
                  cover={<img alt="image de blog Self Tissus" src={item?.image?.url ? item?.image?.url : imgBlogDefault} 
                  // onClick={() => window.location.href = item?.BTNUrl}
                  />}
                >
                  <Infos>
                    <span>{FormateDate(item?.Date)}</span> 
                  </Infos>
                  <Title className="blog grey">{item?.Titre}</Title>
                  <ReactMarkdown className="contBlog">{item?.Contenu}</ReactMarkdown>
                  <a className="orange bold" href={item?.slug} target="_blank">Voir l'article</a>
                </CardStyled>
              );
            })
          }
        </WrapperBlogs>
        {/* {isLoading && <SpinnerHP />}  */}
        
      </Section>
  );
}